export const QUESTION_ID = 'getAnswers';



// WEBPACK FOOTER //
// ./src/containers/Home/sections/Quiz/constants.js